<template>
  <circle cx="35" cy="35" r="35" fill="#F1F4F7" />
  <path
    d="M53.167 41.9428L56 39.0852"
    stroke="#E5EAF4"
    stroke-width="0.36"
    stroke-linecap="round"
  />
  <path
    d="M55.8336 41.9855L53.0894 39.0426"
    stroke="#E5EAF4"
    stroke-width="0.36"
    stroke-linecap="round"
  />
  <path
    d="M15.0693 25.4256L16.094 21.5343"
    stroke="#E5EAF4"
    stroke-width="0.36"
    stroke-linecap="round"
  />
  <path
    d="M17.4 24.1292L13.5519 22.9527"
    stroke="#E5EAF4"
    stroke-width="0.36"
    stroke-linecap="round"
  />
  <path
    d="M14.2985 54.8989L17.9964 53.3124"
    stroke="#E5EAF4"
    stroke-width="0.36"
    stroke-linecap="round"
  />
  <path
    d="M16.7544 55.9386L15.3143 52.1812"
    stroke="#E5EAF4"
    stroke-width="0.36"
    stroke-linecap="round"
  />
  <rect
    x="24.6328"
    y="16.0002"
    width="25.3944"
    height="33.7961"
    rx="0.2"
    fill="#A3B1D1"
    stroke="#8497C2"
    stroke-width="0.4"
    stroke-linejoin="round"
  />
  <rect
    x="23.1219"
    y="17.6473"
    width="25.7944"
    height="34.1961"
    rx="0.4"
    fill="#DDE3F0"
  />
  <rect
    x="21.4016"
    y="19.357"
    width="25.7944"
    height="34.1961"
    rx="0.4"
    fill="white"
  />
  <path
    d="M34.5679 21.5519V17.4565C34.5679 16.4118 35.7193 16.4118 35.7193 17.4565C35.7193 18.5953 35.7193 21.4367 35.7193 22.5534C35.7193 23.9492 33.0016 24.0321 33.0016 22.5534C33.0016 21.1949 33.0016 17.2493 33.0016 15.7815C33.0016 13.0618 36.8707 13.2189 36.8707 15.7815"
    stroke="#8497C2"
    stroke-width="0.4"
    stroke-linecap="round"
  />
  <rect
    x="28.0328"
    y="25.4002"
    width="12.4"
    height="1.2"
    rx="0.4"
    fill="#8497C2"
  />
  <path
    d="M37 30H44.6C44.8209 30 45 30.1791 45 30.4V30.6C45 30.8209 44.8209 31 44.6 31H38L37 30Z"
    fill="#D0D7E7"
  />
  <path
    d="M24 30.4C24 30.1791 24.1791 30 24.4 30H28L27.5 31H24.4C24.1791 31 24 30.8209 24 30.6V30.4Z"
    fill="#D0D7E7"
  />
  <rect
    x="24.4109"
    y="47.1414"
    width="6.01869"
    height="0.854902"
    rx="0.4"
    fill="#A3B1D1"
  />
  <path
    d="M40.2437 35.6218C40.2437 39.8313 36.8313 43.2437 32.6218 43.2437C28.4124 43.2437 25 39.8313 25 35.6218C25 31.4124 28.4124 28 32.6218 28C36.8313 28 40.2437 31.4124 40.2437 35.6218ZM26.1433 35.6218C26.1433 39.1998 29.0438 42.1004 32.6218 42.1004C36.1998 42.1004 39.1004 39.1998 39.1004 35.6218C39.1004 32.0438 36.1998 29.1433 32.6218 29.1433C29.0438 29.1433 26.1433 32.0438 26.1433 35.6218Z"
    fill="#8497C2"
  />
  <rect
    x="29.6491"
    y="38.0409"
    width="7.62518"
    height="0.830707"
    rx="0.415354"
    transform="rotate(-45 29.6491 38.0409)"
    fill="#8497C2"
  />
  <rect
    width="7.62518"
    height="0.832647"
    rx="0.416324"
    transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.629 38.0402)"
    fill="#8497C2"
  />
  <path
    d="M38.3842 39.7259L44.1709 45.5126C44.6288 45.9705 44.6288 46.7129 44.1709 47.1708C43.7129 47.6288 42.9705 47.6288 42.5126 47.1708L36.7259 41.3842L38.3842 39.7259Z"
    fill="#8497C2"
  />
</template>
